import { Component, Vue } from 'vue-property-decorator';
import { namespace } from 'vuex-class';
import { Logger } from 'fsts';


const logger = new Logger('vme-statistic-iframe');

// should have method on backen since here if send request to `api.vme...` then get CORS error and in `no-cors` mode always get 401 error see (https://stackoverflow.com/questions/57615599/fetch-endpoint-with-basic-auth-gives-401)

const authModule = namespace('auth');

@Component({
  components: {},
})
export default class VmeStatistic extends Vue {
  @authModule.Action('getVmeStatisticsData')
  private actionGetVmeStatisticsData!: any;

  initUrl = 'https://ff-statistic.meinvmeint.de';
  proxyUrl = '';

  get isRealXl() {
    return this.$vuetify.breakpoint.width < 1920;
  }

  created() {
    logger.log('this.$route :>> ', this.$route);
    this.loadVmeData();

    const header = document.querySelector('header');
    header?.remove();
    const leftMenu = document.querySelector('.left-menu.v-navigation-drawer');
    leftMenu?.setAttribute('style', 'display: none');
    const app: any = document.querySelector('.v-application--wrap');
    app.style.setProperty('background', 'white'); //  = 'white !important';
  }


  loadVmeData() {
    this.actionGetVmeStatisticsData(this.initUrl)
      .then((result: any) => {
        // console.log('result loadVmeData :>> ', result.data);
        this.proxyUrl = result.data;
      })
      .catch((err: any) => {
        logger.error('Failed to load VME statistics data', err);
      });
  }

}



